<template>
  <div class="card event_card_item">
    <div class="card-img">
        <a :href="item.url"><img :src="item.image_url" class="img-fluid" alt="event" /></a>
    </div>
    <div class="card-body">
        <div class="event_head">
            <h6><a :href="item.url">{{ item.title  }}</a></h6>
            <a href="#" class="share_btn" title="Share">

            </a>
        </div>
        <div class="event_body">
            <ul>
                <li>
                    <i class="las la-calendar"></i>
                    <span>{{ item.start }} </span>
                </li>
                <li>
                    <i class="las la-user"></i>
                    <span>{{ item.contributor }} </span>
                </li>
                <li>
                    <i style="top:-2px;"><img src="assets/images/green-points-icon.jpeg" class="img-fluid green_icon" alt=""></i>
                    <span>{{ item.earn_coins }} </span>
                </li>
            </ul>
            <a :href="item.url" class="btn_link">Read More <i class="las la-angle-right"></i></a>
        </div>
    </div>
</div>

</template>

<script>
export default {
name: "evevnt-card",
props:['item'],
}
</script>

<style>

</style>
